console.log('js/dialogs_edit_package.js -> v0.1.0');
var token = "";

function setToken(token_) {
	token = token_;
}

$(function() {
	//dialogs_edit_package

	var mainText = $('#edit_package_button.mainText').html(),
		altText = 'Cancel'; //make translation variable

	//clicking the edit button toggles the button class and the wrapper class
	$('#edit_package_button').on('click', function() {
		$(this).toggleClass('edit-mode', 'non-edit-mode');
		$("#edit_package").toggleClass('editable', 'noneditable');
		$(this).toggleClass('altText');
		$('#remote_edit_package_button').toggleClass('hide');
		$('.mainText').html(mainText);
		$('.altText').text(altText);
		return false;
	});

	$('#remote_edit_package_button').on('click', function(){
		$('#edit_package_button').trigger('click');

		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - (25)
			}, 400);
			return false;
		}

		return false;
	});

	// To be called if the form submits successfully
	$('#edit_package').bind('successCallback', function(){
		$('.package_element .show .price').html($('#price').val());
		$('.package_element .show .package-attributes').html($('#menu1').html());
		$('#arrival_date_show').html($('#arrival_date_picker').val());
		$('#departure_date_show').html($('#departure_date_picker').val());
		$('#listing_title_show').html($('#listing_title').val());
		$('#edit_package_button').click();

		$(location).attr('href', "/organizer/inquiries/"+token+"/state/default");
	});
});

